import http from '../../../../api/http'

function retrieveAllUserMatchingList(paramObj) {
    return http.post('/admin/matching/retrieveAllPagingUserMatching', paramObj)
}

function retrieveMatchingList(paramObj) {
    return http.post('/admin/matching/retrieveAllPagingMatching', paramObj)
}

function retrieveMatchingTotalCount(paramObj) {
    return http.post('/admin/matching/retrieveMatchingTotalCount', paramObj)
}

function retrieveCorp(corpId) {
    return http.post('/admin/matching/retrieveCorporationBasicInfo', corpId)
}

function retrieveCorpEmpList(paramObj) {
    return http.post('/admin/matching/retrieveCorpEmpListPaging', paramObj)
}

function retrieveCorpMatchingList(paramObj) {
    return http.post('/admin/matching/retrieveCorpMatchingListPaging', paramObj)
}

function updateAdminCorpMasterYn(paramObj) {
    return http.post('/admin/matching/updateCorpMasterYn', paramObj)
}

function retrieveMasterYnCount(corpId) {
    return http.post('/admin/matching/retrieveMasterYnCount', corpId)
}

function retrieveUserMatchingList(paramObj) {
    return http.post('/admin/matching/retrieveUserMatchingListPaging', paramObj)
}

function retrieveMatchingUserTotalCount(userId) {
    return http.post('/admin/matching/retrieveMatchingUserTotalCount', userId)
}

// 상시채용관 - 회원별 입사지원현황 리스트
function retrieveAllMatchingApplicantListAdminPaging(userId) {
    return http.post('/admin/matching/retrieveAllMatchingApplicantListAdminPaging', userId)
}

// 상시채용관 - 기업별 입사지원 현황 리스트
function retrieveAllMatchingApplicantPaging(userId) {
    return http.post('/admin/matching/retrieveAllMatchingApplicantPaging', userId)
}

// 상시채용관 - 기업별 입사지원 현황 리스트
function retrieveMatchingApplicantListAdminPagingByCorpId(userId) {
    return http.post('/admin/matching/retrieveMatchingApplicantListAdminPagingByCorpId', userId)
}

// 상시채용관 - 입사지원현황 리스트
function retrieveMatchingApplicantListAdminPagingByUserId(paramObj) {
    return http.post('/admin/matching/retrieveMatchingApplicantListAdminPagingByUserId', paramObj)
}

export default {
    retrieveAllUserMatchingList,
    retrieveMatchingList,
    retrieveMatchingTotalCount,
    retrieveCorp,
    retrieveCorpEmpList,
    retrieveCorpMatchingList,
    updateAdminCorpMasterYn,
    retrieveMasterYnCount,
    retrieveUserMatchingList,
    retrieveMatchingUserTotalCount,
    retrieveAllMatchingApplicantListAdminPaging,
    retrieveAllMatchingApplicantPaging,
    retrieveMatchingApplicantListAdminPagingByCorpId,
    retrieveMatchingApplicantListAdminPagingByUserId
}
